const INACTIVITY_TIMEOUT = 36000000; // 1 hour
let inactivityTimer;

export const initInactivityTimer = (handleLogout) => {
    resetInactivityTimer(handleLogout);
    window.addEventListener("mousemove", () => resetInactivityTimer(handleLogout));
    window.addEventListener("keypress", () => resetInactivityTimer(handleLogout));
};

export const resetInactivityTimer = (handleLogout) => {
    if (inactivityTimer) {
        clearTimeout(inactivityTimer);
    }
    inactivityTimer = setTimeout(() => {
        handleLogout();
    }, INACTIVITY_TIMEOUT);
};
